<section style="margin: 3rem;">
    <!-- <div class="dds__btn-toggle-container" data-toggle="dds__button" style="float: right;">
        <label id="toggleLabel">Acceleration: </label>
        <button class="dds__btn-toggle" type="button" role="switch" aria-checked="true" aria-labelledby="toggleLabel" (change) ="onChange()">
            <span class="dds__toggle-txt-off" aria-hidden="false">Off</span>
            <span class="dds__toggle-txt-on" aria-hidden="true">On</span>
            <span class="dds__toggle-circle"></span>
        </button>
    </div> -->
    <span style="font-size: inherit;">Acceleration: </span>
    <span class="switch"
  [class.checked]="checked"
  [class.disabled]="disabled"
  [class.switch-large]="size === 'large'"
  [class.switch-medium]="size === 'medium'"
  [class.switch-small]="size === 'small'"
  [class.switch-labeled]="!!labelOn || !!labelOff" style="top: 5px;">
  <input type="checkbox"
    id="enabled"
    name="enabled"
    [checked]="checked"
    style="display: none;"
    aria-invalid="false">
  <small></small>
  <span class="switch-text" *ngIf="!!labelOn || !!labelOff">
    <span class="on" [innerHtml]="labelOn"></span>
    <span class="off" [innerHtml]="labelOff"></span>
  </span>
</span>

  </section>